export const LOADER_RANDOM_IMAGE_COUNT = 6;
